import { Component, Vue } from 'vue-property-decorator';

import { sessionService } from '@/providers/services/auth/session';

import {COMPETENCY_NAVIGATION_MENUS} from '@/utils/constants';

@Component({
    name: 'competency',
    components: {

    },
})
export default class Competency extends Vue {

    // ----------------------------------------------------------------------
    // Properties

    private competencyNavMenu: any = COMPETENCY_NAVIGATION_MENUS;
    private isGDotView: any;
    private isAddComptency: any;


    // ---------------------------------------------------------------------
    // Hooks
    private created() {
        const session: any = sessionService.getSession();
        this.isGDotView = session.permissions.indexOf('UNIVERSAL_CROSSWALK') !== -1;
        this.isAddComptency = session.permissions.indexOf('ADD_COMPETENCY_MODEL') !== -1;
        const addMenuItem = (name: string, path: string) => {
          if (!this.competencyNavMenu.some((item: any) => item.path === path)) {
            this.competencyNavMenu.push({ name, path });
          }
        };
        if (this.isGDotView) {
          addMenuItem('Universal Mapping', 'gdot');
        }
        if (this.isAddComptency) {
          addMenuItem('Add Competency', 'add-competency');
        }
        this.$store.dispatch('activityStore/fetchCategory');
    }

}
